import * as CLIENT_PRIVILEGES from "./privileges/client";
export const CLIENT_PRIVILEGES_CONFIG = CLIENT_PRIVILEGES;



// WEBPACK FOOTER //
// ./src/config/commonConfig.js